import { BaseService } from '#services/BaseService';
import { http } from '#utils/axios';

class GreyListService extends BaseService {
  constructor() {
    super('/grey-list');
    if (!GreyListService.instance) {
      GreyListService.instance = this;
    }
    return GreyListService.instance;
  }

  moveToBlackList = async ({ id, ...values }) => {
    const { data } = await http({
      data: values,
      method: 'GET',
      url: `${this.endpoint}/${id}/black-list`
    });

    return data;
  };
}

const instance = new GreyListService();
Object.freeze(instance);

export default instance;
